import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Popup from "./popup";
import axios from "axios";


function EquipmentForm(props) {

  const [formData, setFormData] = useState({
    jadId: props.values.jad_id || '',
    fullName: '',
    companyName: '',
    email: '',
    phoneNumber: '',
  });

  const [poup_close, poup_setClose] = useState(false);
  const [loading, setLoading] = useState(false)


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const close_popup = () => {
    poup_setClose(false);
    props.handleCloseInquiryModal();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const queryParams = new URLSearchParams({
      jadId: formData.jadId,
      fullName: formData.fullName,
      companyName: formData.companyName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
    }).toString();

    try {
      const response = await axios.post(`/server/manufacturer-list/equipment-request?${queryParams}`);

      if (response.data.error) {
        console.error('Error fetching data:', response.data.error);
      } else {
        if (response.data.ProfileID) {
          setLoading(false);
          poup_setClose(true);
        } else {
          alert(response.data.message || 'Something went wrong');
          setLoading(false);
        }
      }
    } catch (error) {
      console.error('Error posting data:', error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    // console.log(props.values)
  }, [props])

  if (!props.showInquiryModal) return null;

  const modalContent = (
    <div className="Inquiry_container_filter">
      <div className="Inquiry_container">
        {poup_close && <Popup poup_close={poup_close} close_popup={close_popup} />}
        {loading ? <div className="submiting-loading">Submiting...</div> : null}
        <h3>{props.producttype === 'equipment' ? "Equipment Inquiry" : 'Inventory Inquiry'}</h3>
        <div className={props.producttype === 'equipment' ? "Inquiry_details_container" : 'Inquiry_details_container align-start'}>
          <div className="Inquiry_box">
            {props.producttype === 'equipment' && props.values.thumb && (
              <img src={props.values.thumb} className="Inquiry_box_img" alt="Product" />
            )}
            <div className="equipment-details">
              <h4>
                JAD-ID: <strong>{props.values.jad_id}</strong>
              </h4>
              {props.producttype === 'equipment' ? <p>{props.values.description}</p> : <h5>Description: <strong>{props.values.description}</strong></h5>}
            </div>
            <h4>
              {props.producttype === 'equipment' ? <span>Model: </span> : <span>Part Number: </span>}
              {props.producttype === 'equipment' ? props.values.model : props.values.Parts_number}
            </h4>
            <h4>
              {props.producttype === 'equipment' ? <span>Vintage: </span> : <span>Revision: </span>}
              {props.producttype === 'equipment' ? props.values.vintage : props.values.Revision}
            </h4>

            {props.producttype === 'equipment' && (
              <>
                <h4>
                  <span>Inspection Available:</span>
                  {props.values.Inspection_Available == 0 ? 'No' : 'Yes'}
                </h4>
                <h4>
                  <span>Condition:</span>
                  {props.values.Condition}
                </h4>
              </>
            )}
            <h4>
              <span>Manufacturer:</span>
              {props.values.Manufacturer}
            </h4>
          </div>
          <div className="Inquiry-Form_box">
            <form onSubmit={handleSubmit}>
              <label htmlFor="fname">Full name:</label>
              <br />
              <input type="text" id="fname" name="fullName" value={formData.fullName} onChange={handleChange} required />
              <br />
              <label htmlFor="company">Company name:</label>
              <br />
              <input type="text" id="company" name="companyName" value={formData.companyName} onChange={handleChange} required />
              <br />
              <br />
              <label htmlFor="number">Phone Number:</label>
              <br />
              <input type="tel" id="number" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
              <br />
              <br />
              <label htmlFor="email">Email:</label>
              <br />
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
              <br />
              <br />
              <div className="SUbmit_button">
                <input type="submit" value="Submit" />{" "}
                <span style={{ marginLeft: "5px" }}>&rarr;</span>
              </div>
            </form>
          </div>
        </div>
        <button onClick={props.handleCloseInquiryModal} className="Close_button">
          X
        </button>
      </div>
    </div>
  );

  // Render modal via Portal directly on document.body
  return ReactDOM.createPortal(modalContent, document.body);
}

export default EquipmentForm;
